import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  alignStart: {
    '& > *': {
      alignContent: 'flex-start',
    },
  },
});

const ListItem = React.forwardRef(({
  className, classes, expand, alternativeToggleDisplay, ...rest
}, ref) => {
  return (
    <div
      test="action-item-list-item"
      className={classNames(classes.root, className, {
        [classes.alignStart]: expand,
      })}
      ref={ref}
      {...rest}
    />
  );
});

ListItem.defaultProps = {
  className: '',
};

ListItem.propTypes = {
  expand: PropTypes.bool.isRequired,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ListItem);
